import React from 'react';
import Button from './ui/Button';
import { IconTrash } from './ui/Icons';
import { isPfAktiv } from './TransaktionAnlegen.utils';
import { formatCurrencyInput } from '../utils/formatUtils';

const ForderungenForm = ({ persoenlicheForderungen, addPersoenlicheForderung, removePersoenlicheForderung, handlePersoenlicheForderungChange, errors, renderFieldErrors }) => {
  return (
    <div className="form-section">
      <div className="section-header">
        <h3 className="section-title">Persönliche Forderungen</h3>
        <Button variant="outline-primary" size="xs" icon ariaLabel="Forderung hinzufügen" onClick={addPersoenlicheForderung} tooltip="Forderung hinzufügen">+</Button>
      </div>

      {persoenlicheForderungen.map((forderung, index) => {
        const aktiv = isPfAktiv(forderung);
        const reqStar = aktiv ? <span className="required-star">*</span> : null;
        return (
          <div key={forderung.id} className="grundpfandrecht-item">
            {index > 0 && <hr className="section-divider" />}
            {persoenlicheForderungen.length > 1 && (
              <div className="block-header">
                <span className="grundpfandrecht-title">{index + 1}. Persönliche Forderung</span>
                <Button variant="danger" size="xs" icon ariaLabel="Forderung löschen" onClick={() => removePersoenlicheForderung(forderung.id)} tooltip="Forderung löschen">
                  <IconTrash width="12" height="18" />
                </Button>
              </div>
            )}

            <div className="form-row">
              <div className="form-field full-width">
                <label htmlFor={`forderung-aktenzeichen-${forderung.id}`}>Aktenzeichen {reqStar}</label>
                <input
                  id={`forderung-aktenzeichen-${forderung.id}`}
                  type="text"
                  value={forderung.aktenzeichen}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'aktenzeichen', e.target.value)}
                  className={errors[`pf_${forderung.id}_aktenzeichen`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. PF-2024-001"
                  maxLength={100}
                />
                {renderFieldErrors(`pf_${forderung.id}_aktenzeichen`)}
              </div>
            </div>

            <div className="form-row">
              <div className="form-field full-width">
                <label htmlFor={`forderung-vorgangsnr-${forderung.id}`}>Darlehen-Nr. {reqStar}</label>
                <input
                  id={`forderung-vorgangsnr-${forderung.id}`}
                  type="text"
                  value={forderung.vorgangsNr}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'vorgangsNr', e.target.value)}
                  className={errors[`pf_${forderung.id}_vorgangsNr`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. VG-2024-123"
                  maxLength={100}
                />
                {renderFieldErrors(`pf_${forderung.id}_vorgangsNr`)}
              </div>
            </div>

            <div className="form-row two-equal">
              <div className="form-field">
                <label htmlFor={`forderung-vorname-${forderung.id}`}>Vorname {aktiv && errors[`pf_${forderung.id}_vornameSchuldner`] ? <span className="required-star">*</span> : null}</label>
                <input
                  id={`forderung-vorname-${forderung.id}`}
                  type="text"
                  value={forderung.vornameSchuldner}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'vornameSchuldner', e.target.value)}
                  className={errors[`pf_${forderung.id}_vornameSchuldner`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. Max"
                  maxLength={100}
                />
                {renderFieldErrors(`pf_${forderung.id}_vornameSchuldner`)}
              </div>
              <div className="form-field">
                <label htmlFor={`forderung-name-${forderung.id}`}>Name {reqStar}</label>
                <input
                  id={`forderung-name-${forderung.id}`}
                  type="text"
                  value={forderung.nameSchuldner}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'nameSchuldner', e.target.value)}
                  className={errors[`pf_${forderung.id}_nameSchuldner`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. Mustermann"
                  maxLength={100}
                />
                {renderFieldErrors(`pf_${forderung.id}_nameSchuldner`)}
              </div>
            </div>

            <div className="form-row long-short">
              <div className="form-field">
                <label htmlFor={`forderung-betrag-${forderung.id}`}>Betrag {reqStar}</label>
                <input
                  id={`forderung-betrag-${forderung.id}`}
                  type="text"
                  value={forderung.betrag}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'betrag', formatCurrencyInput(e.target.value))}
                  className={errors[`pf_${forderung.id}_betrag`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. 50.000,00"
                />
                {renderFieldErrors(`pf_${forderung.id}_betrag`)}
              </div>
              <div className="form-field">
                <label htmlFor={`forderung-waehrung-${forderung.id}`}>Währung {reqStar}</label>
                <select
                  id={`forderung-waehrung-${forderung.id}`}
                  value={forderung.waehrung}
                  onChange={(e) => handlePersoenlicheForderungChange(forderung.id, 'waehrung', e.target.value)}
                  className={errors[`pf_${forderung.id}_waehrung`] ? 'error' : ''}
                >
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                  <option value="CHF">CHF</option>
                </select>
                {renderFieldErrors(`pf_${forderung.id}_waehrung`)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ForderungenForm;
